<script>

    import Selection from "./Selection";
    import State from "./State";

    // TODO Introduce Document component to make this God object smaller?
    // TODO Extract drag / drop functionality?
    export default {

        provide: function()
        {
            return {
                pageComponent: this,
            };
        },

        props: {
            element: Object,
            iframeComponent: Object,
        },

        data()
        {
            return {
                selection: new Selection(),
                state: new State({
                    propsData: {
                        initialCanvasVersion: JSON.parse(JSON.stringify(window.canvasEditorIframeComponent.editorComponent.canvasComponent.canvasVersion)), // Not reactive between child (iframe) and parent.
                    },
                }),

                dropPlaceholder: $('<div class="canvas-drop-placeholder" />'),
                isAddingBlock: false,

                // @ugly
                // Will be updated by iframe.vue
                canvasVersion: null,
                activeMode: 'content',
                galleryDraggingBlockId: null,
                scale: null,
            };
        },

        created()
        {
            // @ugly
            // TODO Remove everenteditable', this.$pageComponent().selection.y this.$pageComponent()?
            window.pageComponent = this;

            //
            this.initVueComponents();
            this.initOnNewHtml();
            this.initDroppableBlock();

            this.manageActiveMode();

            // Other components may have added an initial state and from now on we will save changes.
            this.$nextTick(this.state.watchCanvasVersion);
        },

        methods: {

            initVueComponents()
            {
            	//console.info('initVueComponents()');

                // Loop in order of the DOM so we can attach already initialised parents.
                for (let element of $('[data-canvas-editable]', this.element)) {

                	// Init due to not having an instance yet?
                	if(!$(element).data('vue-instance'))
					    this.initEditableElement($(element));
				}
            },

            initEditableElement(element)
            {
            	// console.info('initEditableElement()', { element })

                // Get Vue component.
                let vueComponent = this.getEditorComponent(element);

                // Init Vue component.
                new vueComponent({
                    parent: this.getVueParentOfElement(element),
                    propsData: {
                        element,
                    }
                });
            },

            getVueParentOfElement(element)
            {
				// Determine parent.
				let parentElement = element.parent().closest('[data-vue-component]');

				// Get Vue parent from parent?
				if(parentElement.length)
				{
					// Get vue instance.
					let vueInstance = parentElement.data('vueInstance');

					// Error due to none found?
					if(!vueInstance)
						throw {
							msg: 'No vue parent found on element with [data-vue-component]!',
							element,
							parentElement,
						};

					//
					return vueInstance;
				}
				// Is root?
                else {
					return this;
				}
			},

            getEditorComponent(element)
            {
                // Get canvas block.
                let canvasBlock = this.state.id2canvasBlock[this.getBlockIdFromElement(element)];

                // Get editor name.
                let editorName = ($(element).data('canvas-editable').editor || 'editor').toLowerCase();

                let componentTagPrefixComponentNamespace = '',
                    canvasBlockName = '';

                // Determine component prefix and canvas block name
                if (canvasBlock.block.includes('::')) {
                    componentTagPrefixComponentNamespace = canvasBlock.block.split('::')[0] + '--';
                    canvasBlockName = canvasBlock.block.split('::')[1].replace('.', '-').toLowerCase();
                } else {
                    canvasBlockName = canvasBlock.block.replace('.', '-').toLowerCase();
                }

                // Determine component tags.
                let componentTags = {
                    block: componentTagPrefixComponentNamespace + 'common-canvas-blocks-' + canvasBlockName + '-admin-' + editorName,
                    default: 'common-canvas-editor-canvas-document-editors-' + editorName,
                };

                // Determine component.
                let component = window.Vue.options.components[componentTags.block] || window.Vue.options.components[componentTags.default];

                // Throw error due to not found?
                if(!component)
                    throw {
                        msg: 'No component found for element! Guessed element: '  + componentTags.block,
                        element,
                        componentTags,
                    };

                //
                return component;
            },

            getBlockIdFromElement(element)
            {
                // Loop self + editable parents.
                for(let parentElement of [element].concat(element.parents('[data-canvas-editable]').get()))
                {
                    // Get block id.
                    let blockId = $(parentElement).data('canvas-editable').blockId;

                    // Found?
                    if(blockId)
                        return blockId;
                }

                //
                throw 'No block found in parents!';
            },

            removeVueComponents(baseElement = null, andSelf = false)
            {
            	//console.info('removeVueComponents', { baseElement });

                // Loop each.
                $('[data-vue-component]', baseElement)
                    .add(andSelf ? baseElement : null)
                    .each((index, element) =>
                    {
                        // Destroy
                        let instance = $(element).data('vue-instance');

                        //console.info({element, instance})

                        if(instance)
                        	instance.$destroy();
                    });
            },

            reinitVueComponents(baseElement = null, andSelf = false)
            {
            	//console.info('reinitVueComponents()', { baseElement });

				this.removeVueComponents(baseElement, andSelf);
				this.initVueComponents();
            },

            initOnNewHtml()
            {
                // Listen for new content after save.
                this.state.$on('newHtml', html =>
                {
                    this.selection.restoreSelectionAfterNewHtml(selectionRestorer =>
                    {
                        // Get current scroll offset.
                        let scrollOffset = $('html, body').scrollTop();

                        //
                        this.removeVueComponents();

                        // Set new content.
                        $('.galaxy\\:\\:common-Canvas', this.element)
                            .replaceWith($(html).find('.galaxy\\:\\:common-Canvas:first'));

                        // Reinit views.
                        common.View.reinit(() =>
                        {
                            // Init Vue components when DOM is ready.
                            this.initVueComponents();

                            //
                            selectionRestorer();

                            // Restore scroll offset.
                            $('html, body').scrollTop(scrollOffset);

                            //
                            this.$emit('rendered');
                        });
                    });
                });
            },

            getEditors()
            {
            	// @ugly
				this.initVueComponents();

				//
				return _.map($('[data-canvas-editable]'), element => {

                	let instance = $(element).data('vue-instance');

                	// @debug
                	if(!instance)
                		debugger;

                	return instance;
                });
            },

            manageActiveMode()
            {
                // Pass to selection.
                this.selection.activeMode = this.activeMode;

                // Adjust UI.
                this.element.toggleClass('canvas-overview', this.activeMode == 'overview');
            },

            initDroppableBlock()
            {
                // Listen for drag / drop interaction.
                this.element
                    .on('dragover', this.onDragOver)
                    .on('drop', this.onDrop);
            },

            onDragOver(event)
            {
                // Abort due to not in right mode?
                if(this.activeMode != 'overview')
                    return;

                // Get block below.
                let blockBelow = this.getBlockBelowDroppable(event);

                // Add below existing block?
                if(blockBelow)
                    $(blockBelow).after(this.dropPlaceholder);

                // Add as first block?
                else
                    this.element.find('.galaxy\\:\\:common-Canvas').prepend(this.dropPlaceholder);

                //
                event.preventDefault();
            },

            // TODO Unused
            removeDropPlaceholder()
            {
                this.dropPlaceholder.remove();
            },

            getBlockBelowDroppable(event)
            {
                // First element.
                let firstBlock = null;
                let mouseY = this.element.closest('html').scrollTop() + event.clientY;

                // Loop blocks.
                for(let block of this.element.find('.galaxy\\:\\:common-Canvas > *[data-canvas-editable]').toArray())
                {
                    // Get middle coordinate of block.
                    let blockMiddle = $(block).position().top + $(block).outerHeight() / 2;

                    // Abort due to far down?
                    if(mouseY < blockMiddle)
                        break;

                    // Set as canditate.
                    firstBlock = block;
                }

                //
                return firstBlock;
            },

            onDrop(event)
            {
                // Abort due to not in right mode?
                if(this.activeMode != 'overview')
                    return;

                //
                event.preventDefault();

                // Determine new index between root blocks.
                let canvasBlocks = this.state.canvasVersion.canvas_blocks;
                let blockBelow = this.getBlockBelowDroppable(event);

                let newIndex = blockBelow ? canvasBlocks.indexOf($(blockBelow).data('vueInstance').canvasBlock) + 1 : 0;

                //
                this.addBlock(this.galleryDraggingBlockId, newIndex);
            },

            addBlock(blockId, index)
            {
                // Add after?
                if(index === undefined)
                    index = this.state.canvasVersion.canvas_blocks.length;

                // Disable deleting the placeholder on releasing the mouse.
                this.isAddingBlock = true;

                // Listen for upcoming update of HTML which means it has been saved on the server.
                this.state.$once('newHtml', () => this.isAddingBlock = false);

                // Add new block to index.
                let canvasBlocks = this.state.canvasVersion.canvas_blocks;

                canvasBlocks.splice(index, 0, {
                    block: blockId,
                });
            },

        },

        watch: {

            'activeMode'(newVal)
            {
                this.manageActiveMode();
            },

            'galleryDraggingBlockId'(newVal)
            {
                // Dragging stopped?
                if(!this.newVal && !this.isAddingBlock)
                    this.removeDropPlaceholder();
            },

            'state.saving'(newVal)
            {
                this.element.toggleClass('saving', newVal);
            },

            'selection.enabled'(newVal)
            {
                this.element.toggleClass('selectable', newVal);
            },

        }

    }

</script>

<style lang="scss">

.galaxy\:\:common-canvas-editor-canvas-document-Page {

    @apply tw-h-full;

    &.canvas-overview {
        background: #ecf0f1;
        @apply tw-p-20;

        // Overrule Bootstrap container.
        .container {
            max-width: 100%;
        }
    }

    * {
        user-select: none;

        &[contenteditable="true"], .cke_dialog {
            &,
            * {
                user-select: auto;
            }
        }

    }

    input, textarea, select {
        user-select: auto;
    }

    img {
        user-drag: none;
    }

    .cke_editable {
        img {
            cursor: pointer;
        }
    }

    // TODO Place elsewhere?
    // Disable interaction in canvas.
    .galaxy\:\:common-Canvas {

        input,
        select,
        textarea {
            pointer-events: none;
        }

    }

    &.saving > .habitats-website-layouts-Main > .galaxy\:\:common-Canvas {
        cursor:     wait;
        opacity:    .6;
        transition: opacity .2s;

        > * {
            pointer-events: none;
        }
    }

    .canvas-drop-placeholder {
        @apply tw-shadow-lg tw-bg-white tw-border-2 tw-ring-blue-500 tw-border-blue-500;
        height:        222px;
        margin-bottom: 60px !important;
    }

}

</style>
